import React from "react";
import "./contact.css";

const Contact = () => {
  const email = "nagavamsireddysatti@gmail.com";
  const whatsappNumber = "+447741022310";

  const whatsappLink = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
    whatsappNumber
  )}&text=${encodeURIComponent(
    "Hello Vamsi, I saw your portfolio and would like to discuss an opportunity."
  )}`;

  return (
    <section className="contact section" id="contact">
      <h2 className="section__title">Get in touch</h2>
      <span className="section__subtitle">Contact Me</span>

      <div className="contact__container container grid">
        <div className="contact__content">
          <h3 className="contact__title">Talk to me</h3>

          <div className="contact__info">
            <div className="contact__card">
              <i className="bx bx-mail-send contact__card-icon"></i>
              <h3 className="contact__card-title">Email</h3>
              <span className="contact__card-data">{email}</span>
              <a href={`mailto:${email}`} className="contact__button">
                Write me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>

            <div className="contact__card">
              <i className="bx bxl-whatsapp contact__card-icon"></i>
              <h3 className="contact__card-title">WhatsApp</h3>
              <span className="contact__card-data">{whatsappNumber}</span>
              <a
                href={whatsappLink}
                className="contact__button"
                target="_blank"
                rel="noreferrer"
              >
                Write me
                <i className="bx bx-right-arrow-alt contact__button-icon"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
